import { Action } from '../../actions';
import { firstReferenceFromReferenceList, mergeObject } from '../../helpers';

import { transformNavigationUserInfo } from './user-info.transformers';

export function navigationUserInfoReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'navigationUserInfo') {
        const { result, refList } = action.payload;
        return mergeObject<'navigationUserInfo'>(
          state,
          transformNavigationUserInfo(result),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/es/webapp/src/app/@shared/datastore/navigation/user-info/user-info.reducer.ts